import { render } from "./VocabularyDetailsPage.vue?vue&type=template&id=b0275cec&ts=true"
import script from "./VocabularyDetailsPage.vue?vue&type=script&lang=ts"
export * from "./VocabularyDetailsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__